import { FunctionComponent } from 'react';
import { IconProps } from '../../../lib/types';

const ChevronDown: FunctionComponent<IconProps> = ({
  onClick,
  className,
}) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
};

export default ChevronDown;
